// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_F02YU::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  background-clip: padding-box;
  border-radius: 8px;
}

 .table_F02YU::-webkit-scrollbar {
  display: block;
  width: 10em;
  overflow: auto;
  height: 8px;
  border-radius: 8px;
}

.row_mgLuo {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 70px;
}

.ellipsizeLeft_AcT4h {
  white-space: wrap;
}

`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/headCount/components/Tables.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;CAEC;EACC,cAAc;EACd,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".table::-webkit-scrollbar-thumb {\n  background-color: #c1c1c1;\n  background-clip: padding-box;\n  border-radius: 8px;\n}\n\n .table::-webkit-scrollbar {\n  display: block;\n  width: 10em;\n  overflow: auto;\n  height: 8px;\n  border-radius: 8px;\n}\n\n.row {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  line-height: 70px;\n}\n\n.ellipsizeLeft {\n  white-space: wrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_F02YU`,
	"row": `row_mgLuo`,
	"ellipsizeLeft": `ellipsizeLeft_AcT4h`
};
export default ___CSS_LOADER_EXPORT___;
